import { useTranslation } from 'react-i18next'
import useRole from '@/hooks/use-role'
import AnalyzingCredit from './analyzing-credit'
import AverageCredit from './average-credit'
import ExcellentCredit from './excellent-credit'
import GoodCredit from './good-credit'
import NotEnoughCredit from './not-enough-credit'
import PoorCredit from './poor-credit'
import UnknownCredit from './unknown-credit'
import InternationalUser from './international-user'
import SubmittedCredit from './submitted-credit'
import SubmittedRequest from './submitted-request'

const CardTypes = {
  excellent: ExcellentCredit,
  'very good': GoodCredit,
  average: AverageCredit,
  poor: PoorCredit,
  'not enough': NotEnoughCredit,
  'N/A': UnknownCredit,
  analyzing: AnalyzingCredit,
  request: SubmittedRequest
}

const getCardType = (rating, isInternationalUser, isRenter, hasTrustScore, isRequestSubmitted) => {
  if (isInternationalUser) {
    return InternationalUser
  }

  if (isRequestSubmitted && isRenter) {
    return SubmittedRequest
  }

  if (rating || hasTrustScore) {
    if (isRenter && (['not enough', 'N/A'].indexOf(rating) === -1 || hasTrustScore)) {
      return SubmittedCredit
    } else {
      return CardTypes[rating]
    }
  }

  return UnknownCredit
}

const LivScoreCard = props => {
  const { t } = useTranslation()
  const hasTrustScore = props.user?.trust_score?.submitted
  const rating = props.creditDetails?.credit_rating
  const isRequestSubmitted = !props.user?.profile_progress?.liv_score?.missing?.liv_verified_state

  const isInternationalUser = props.user.international_user === '1'
  const isRenter = useRole() === 'tenant'
  const Card = getCardType(rating, isInternationalUser, isRenter, hasTrustScore, isRequestSubmitted)

  const title =
    props.userRole === 'tenant'
      ? t('r.liv_score_card.view.current_score.title', 'Trust Score')
      : t('l.liv_score_card.view.tenant_score.title', 'Tenant Score')

  return <Card title={title} {...props} />
}

LivScoreCard.defaultProps = {
  userRole: 'tenant'
}

export default LivScoreCard
